import { gql, TypedDocumentNode } from "@apollo/client";
import { MEMBERSHIP_BAND_FRAGMENT } from "@/fragments";

export type UpdateMembershipInput = {
  personId: string;
  classificationId: string;
  sectionId: string;
  startedOn: string;
  note?: string | null;
};

export const UPDATE_MEMBERSHIP_MUTATION: TypedDocumentNode<
  {
    updateMembership: {
      success: boolean;
      message: string;
      band?: {
        id: string;
        person: {
          id: string;
          bands: Array<{
            id: string;
          }>;
        };
      };
    };
  },
  { input: UpdateMembershipInput }
> = gql`
  mutation UpdateMembership($input: BackofficeUpdateMembershipInput!) {
    updateMembership(input: $input) {
      success
      message
      band {
        id
        person {
          id
          bands {
            id
            ...MembershipBandFragment
          }
        }
      }
    }
  }
  ${MEMBERSHIP_BAND_FRAGMENT}
`;

export type LifeMemberClassification = "LMA" | "LMMA" | "LM" | "LMM" | "RM" | "LMC" | "RSV";

export const CREATE_NON_ACTIVE_CLASSIFICATION_TASK_MUTATION: TypedDocumentNode<
  {
    createNonActiveClassificationTask: {
      success: boolean;
      message: string;
      task?: {
        id: string;
        name: string;
      } | null;
    };
  },
  {
    personId: string;
    classification: LifeMemberClassification;
    note?: string | null;
    attestationAcknowledged?: boolean | null;
  }
> = gql`
  mutation CreateNonActiveClassificationTask(
    $personId: ID!
    $classification: LifeMemberClassification!
    $note: String
    $attestationAcknowledged: Boolean
  ) {
    createNonActiveClassificationTask(
      personId: $personId
      classification: $classification
      note: $note
      attestationAcknowledged: $attestationAcknowledged
    ) {
      success
      message
      task {
        id
        name
      }
    }
  }
`;
